export default {
    state: {
        certificate: {}
    },
    actions: {
        CHECK_CERTIFICATE({ commit, state }, payload) {
            return window.axios
                .get(`/api/app/certificate/check/${payload.code}`)
                .then(res => {
                    return res;
                })
                .catch(err => {
                    return err;
                })
        }
    }
}
